import { Paper } from "@mui/material";
import { ReactNode } from "react";

interface SectionCardProps {
  children: ReactNode;
}

/**
 * Pale-gray surface that frames a drawer section, matching the stat cards on
 * the manifest list page. Sections keep their own internal headers; this is
 * just the quiet card around them.
 */
export function SectionCard({ children }: SectionCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        // 24px around the widget; a touch less (16px) on top so the tall
        // overline section labels don't sit too far from the edge.
        pt: 2,
        px: 3,
        pb: 3,
        borderRadius: 2,
        // Fill the (flex-stretched) cell so side-by-side cards — e.g. Summary +
        // Timeline — stay equal height; a no-op for full-width stacked sections.
        height: "100%",
        backgroundColor: (theme) => theme.palette.surfaceSubtle,
      }}
    >
      {children}
    </Paper>
  );
}
